import React, { memo } from "react";
import styled from "styled-components";
import { defaultLogo } from "../../../ThirdScreen/qrSettings/logotypeQr/svg";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";

export function getLightOrBlackColor(color, lightColor, darkColor) {
  const hex = color.replace("#", "");
  const c_r = parseInt(hex.substr(0, 2), 16);
  const c_g = parseInt(hex.substr(2, 2), 16);
  const c_b = parseInt(hex.substr(4, 2), 16);
  const brightness = (c_r * 299 + c_g * 587 + c_b * 114) / 1000;
  return brightness > 155 ? darkColor : lightColor;
}

export default memo(function LinkListBuilder() {
  const { generateQrText, data } = useSelector((state) => ({
    generateQrText: state.changeLang.language.sliderHint.secondSlide.title,
    data: state.linksBuilder.data,
  }));

  return (
    <div
      className="p-4 bg-white position-sticky left-0 rounded-1"
      style={{ top: 165 }}
    >
      <BackGround color={data.colors[0]} className="w-100 rounded-1">
        {data.logo && (
          <TitleImg src={data.logo} isLogoRound={data.isLogoRound} />
        )}
        <Title
          color={getLightOrBlackColor(data.colors[0], "#FFFFFF", "#000000")}
        >
          {data.title}
        </Title>
        <TitleDescription
          color={getLightOrBlackColor(data.colors[0], "#FFFFFF", "#000000")}
        >
          {data.description}
        </TitleDescription>
        {data.links.map((item) => (
          <StyledButton
            className="text-decoration-none"
            key={item.id}
            color={data.colors[2]}
            buttonBack={data.colors[1]}
            back={data.colors[0]}
            target="_blank"
            href={item.url}
          >
            <img src={item.img} />
            {item.text}
          </StyledButton>
        ))}
        <Socials>
          {data.socials.map((item) => {
            const currentLogo = defaultLogo.find((logo) => logo.id === item.id);
            return (
              <a href={item.link} key={item.id}>
                <img
                  src={currentLogo.img}
                  className="img-fluid"
                  width="50"
                  height="50"
                />
              </a>
            );
          })}
        </Socials>
      </BackGround>
      <Button
        className="w-100 mt-4 py-3 h-100 d-flex align-items-center justify-content-center"
        onClick={() => window.document.querySelector("#linkListClick")?.click()}
      >
        {generateQrText}
      </Button>
    </div>
  );
});

const BackGround = styled.div`
  background-color: ${(props) => props.color || "white"};
  height: 526px;
  padding: 30px 10px;
  overflow-y: auto;
`;
const Title = styled.div`
  color: ${(props) => props.color || "black"};
  font-size: 22px;
  text-align: center;
  font-weight: 700;
  line-height: 36px;
  margin-bottom: 2px;
`;
const TitleDescription = styled.p`
  color: ${(props) => props.color || "gray"};
  margin-bottom: 10px;
  font-size: 14px;
  text-align: center;
  line-height: 21px;
  white-space: pre-line;
`;
const StyledButton = styled.a`
  color: ${(props) => props.color || "white"};
  background-color: ${(props) => props.buttonBack || "orange"};
  border: 2px solid ${(props) => props.buttonBack || "orange"};
  &:hover {
    background-color: ${(props) => props.back || "red"};
  }
  width: 100%;
  margin-top: 10px;
  padding: 0 15px;
  border-radius: 8px;
  position: relative;
  flex: 0 0 auto;
  transition: all 0.2s ease-in-out;
  text-align: center;
  height: 53px;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    height: 28px;
    position: absolute;
    left: 10px;
  }
`;

const TitleImg = styled.div`
  width: ${(props) => (props.isLogoRound ? "120" : "180")}px;
  min-height: 120px;
  background: url(${(props) => props.src}) center center no-repeat;
  border-radius: ${(props) => (props.isLogoRound ? "50%" : "0")};
  background-size: ${(props) => (props.isLogoRound ? "cover" : "contain")};
  margin: 0 auto 20px;
`;

const Socials = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 25px;
  justify-content: center;
  svg {
    width: 50px;
    height: 50px;
  }
`;
